import Marquee from "react-fast-marquee";

const ITEMS = [
  "Housemade Salsa",
  "Handmade Tortillas",
  "24-Hour Marinade",
  "No Paid Influencers",
  "Off the Trompo",
  "Nixtamalized Daily",
  "Family Owned",
  "Tip Well",
];

export const EditorialMarquee = ({ reverse = false }) => (
  <div data-testid={reverse ? "marquee-reverse" : "marquee"} className="no-print border-y-2 border-ink bg-paper py-4 overflow-hidden">
    <Marquee speed={32} gradient={false} direction={reverse ? "right" : "left"}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif italic text-2xl sm:text-4xl px-6 whitespace-nowrap">{item}</span>
          <span className="text-salsa font-mono text-lg">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
